import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _CompetitionLevel, _CompetitionType, _Entailment, _MainTheme } from '../../../../core/services/dataBean/EntityCatalog';

interface Props {
    idSelector: number;
    onChange: any;
    IDCompetitionType: any
}

export const Competitionleveleditor = ({ idSelector, onChange, IDCompetitionType }: Props) => {

    const competitionLevel = useDataBean(_CompetitionLevel)
    const [lista, setLista] = useState([]);
    const [id, setID] = useState(0);

    useEffect(() => {
        setID(idSelector);
        getLista();
    }, [IDCompetitionType])

    useEffect(() => {
        onChange(id);
    }, [id])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(id);
    }

    const getLista = () => {

        competitionLevel.instance.getCompetitionLevelCatalog(IDCompetitionType).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    return (
        <>
            <label>Niveles de las Competencias Comportamentales:</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option>...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.IDCompetitionLevel} >{item.DataBeanProperties.Name}</option>
                        )
                    })
                }
            </select>
        </>
    )
}